import StyleToggle from './StyleToggle'
import Globals from './Globals'

const FontToggle = (props) => {
    const onFontSelected = (value) => {
        props.update(value)
    }

    if (Globals.fonts.length < 2) {
        return null
    }

    return (
        <StyleToggle
            value={props.value}
            update={onFontSelected}
            styles={Globals.fonts}
            content={'A'}
            buttonStyleProp={'fontFamily'}
        />
    )
}

export default FontToggle
